export const camelCaseToSentence = (input) => {
    const words = input.replace(/([A-Z])/g, ' $1').trim().split(' ');
    const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    return formattedWords.join(' ');
  }